module.exports = __webpack_public_path__ + "img/4-4.a8e34991.png";